// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application';
import { Application } from '@hotwired/stimulus';
import TabsController from './tabs_controller';

import ChatController from './chat_controller';
application.register('chat', ChatController);

import CodemirrorController from './codemirror_controller';
application.register('codemirror', CodemirrorController);

import CustomDomainController from './custom_domain_controller';
application.register('custom-domain', CustomDomainController);

import AssistantChatController from './assistant_chat_controller';
application.register('assistant-chat', AssistantChatController);

import NavigationController from './navigation_controller';
application.register('navigation', NavigationController);

import OpacitySliderController from './opacity_slider_controller';
application.register('opacity-slider', OpacitySliderController);

import RealTimeColorInputController from './real_time_color_input_controller';
application.register('real-time-color-input', RealTimeColorInputController);

import ServicesController from './services_controller';
application.register('services', ServicesController);

import RegistrationSettingsFormController from './registration_settings_form_controller';
application.register(
  'registration-settings-form',
  RegistrationSettingsFormController
);

import ReplaceContentToggleController from './replace_content_toggle_controller';
application.register('replace-content-toggle', ReplaceContentToggleController);

import UploadController from './upload_controller';
application.register('upload', UploadController);

import CharacterCounterController from './character-counter';
application.register('character-counter', CharacterCounterController);

import StudentServicesController from './student_services_controller';
application.register('student-services', StudentServicesController);

application.register('tabs', TabsController);
